import { observer } from "mobx-react-lite";
import React, { Fragment, useEffect, useState } from "react";
import { useStore } from "../../app/stores/store";
import agent from '../../app/api/agent';
import LoadingComponent from "../../app/layout/LoadingComponent";
import { List } from 'semantic-ui-react'
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';
import EditCursos from "./EditCursos";
import Container from 'react-bootstrap/Container';
import Pagination from 'react-bootstrap/Pagination';

const useStyles = makeStyles({
    table: {
      minWidth: 650,
    },
  });

  var numberPagina: number

export default observer(function ListCursos() {
    const classes = useStyles();
    const {CATCursosStore, modalStore} = useStore();
    const {loadCATCursoss, getCATCursosRegistryAll, totalPages} = CATCursosStore;
    const [currentPage, setCurrentPage] = useState(1);

    useEffect(() => {
      
        loadCATCursoss(currentPage, 10);
      
        
    }, [currentPage, loadCATCursoss])
   

    const handlePageClick = (numberPagina:number) => {
        setCurrentPage(numberPagina);
       
      }

    let active = CATCursosStore.currentPage;
    let items = [];
    for ( let numberPagina = 1; numberPagina <= CATCursosStore.totalPages; numberPagina++) {
      
      items.push(
        <Pagination.Item
          key={numberPagina}
          activeLabel=" Activa"
          active={numberPagina === active}
          onClick={() => {
            handlePageClick(numberPagina);
            CATCursosStore.setPage(numberPagina);
          }}
        >
          {numberPagina}           

        </Pagination.Item>,
      ); 
    }
    

    if (CATCursosStore.loadingInitial) return <LoadingComponent content='Cargando datos..' />

    return (
        <>   <div>
            <TableContainer>
                <Table className={classes.table} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                    {CATCursosStore.getCATCursosByCodigoAll.map((item:any) => {
                        return (
                            <TableRow key={item.id}>
                                <TableCell component="th" scope="row">
                                    {/* <DescriptionOutlinedIcon /> */}
                                    <img style={{width: "120px", height: "100px"}} src={item.imageUrl} />
                                </TableCell>
                                <TableCell>
                                    {item.nombre}
                                </TableCell>
                                <TableCell align="right">
                                    <IconButton aria-label="delete" onClick={() => {modalStore.openModal(
                                        <EditCursos idCurso={item.id}/>, 'large' )}}>
                                        <EditIcon />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        )
                    })}
                    </TableBody>
                </Table>
            </TableContainer> 

            </div>

            <div style={{marginTop: "10px"}}> 
                <Container className='pagination-convenios-area'>
                <Pagination>{items}</Pagination>
                </Container>

            </div>


        </>
    )
})

